import { combineReducers } from 'redux';

import collectionReducer from '../collectionReducer';

function releaseNotesReducer({ category }) {
    const collectionReducerFn = collectionReducer({
        collectionActionName: `${category}_RELEASE_NOTES`,
        defaultState: { unread: false },
        itemActionName: `${category}_RELEASE_NOTE`,
    });

    return (state, action) => {
        const reducedState = collectionReducerFn(state, action);
        if (action.type === 'UNREAD_RELEASE_NOTES_SUCCESS') {
            return { ...reducedState, unread: Boolean(action.payload[category.toLowerCase()]) };
        }
        return reducedState;
    };
}

const backend = releaseNotesReducer({ category: 'BACKEND' });

const cleverland = releaseNotesReducer({ category: 'CLEVERLAND' });

const cleverservice = releaseNotesReducer({ category: 'CLEVERSERVICE' });

const reducer = combineReducers({
    backend,
    cleverland,
    cleverservice,
});

export default reducer;
